import { messageFromOrchestratorAxiosError } from './axiosErrorMessage';

/** Anti-enumeration copy — same for unknown email and wrong password (auth-server parity). */
export const INVALID_CREDENTIALS_MESSAGE =
  'Invalid email or password. Please try again.';

/** Axios-shaped 401 for login responses that omit userId without an HTTP error. */
export function invalidCredentialsAxiosError(message?: string) {
  const bodyText = message?.trim() || 'Invalid email or password';
  return {
    response: {
      status: 401,
      data: { error: bodyText, message: bodyText },
    },
    message: 'Request failed with status code 401',
  };
}

/**
 * Password / email login rejected (HTTP 401). Covers auth-server wording and
 * orchestrator fallback "Login failed".
 */
export function isInvalidCredentialsError(err: unknown): boolean {
  const ax = err as { response?: { status?: number; data?: unknown }; message?: string };
  if (ax.response?.status !== 401) return false;

  const data = ax.response?.data;
  const bodyText =
    data && typeof data === 'object'
      ? [(data as Record<string, unknown>).message, (data as Record<string, unknown>).error]
          .filter((x): x is string => typeof x === 'string')
          .join(' ')
      : '';
  const fromBody = messageFromOrchestratorAxiosError(err);
  const combined = [bodyText, fromBody, ax.message].filter(Boolean).join(' ');

  if (/invalid email or password/i.test(combined)) return true;
  if (/login failed/i.test(combined)) return true;
  if (/invalid credentials/i.test(combined)) return true;
  if (/unauthorized/i.test(combined)) return true;

  // Default: auth login 401s are invalid credentials (not session expiry probes).
  return true;
}
